/**
 * site-principles-crossfade.js
 *
 * Секция «6 шагов» (.site-principles): при закреплении (pin) слайды лежат стопкой;
 * при вертикальном скролле предыдущий слой растворяется, следующий проявляется
 * (autoAlpha), без горизонтального смещения.
 */

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const HEADER_STICKY_PX = 100

/** Множитель «виртуального» скролла на один переход между соседними шагами */
const SCROLL_END_MULTIPLIER = 1.12

/** Доля таймлайна (0–1) до первого переключения — первый шаг читают без смены */
const PIN_SCROLL_HOLD_BEFORE_STEPS = 0.18

const SCRUB_SMOOTHING = true

const REFRESH_DEBOUNCE_MS = 120

export function initSitePrinciplesCrossfade() {
  const section = document.querySelector('.site-principles')
  if (!section) return

  const track = section.querySelector('.site-principles__track')
  const grid = section.querySelector('.site-principles__grid')
  if (!(track instanceof HTMLElement) || !(grid instanceof HTMLElement)) return

  const cards = grid.querySelectorAll('.site-principles__card')
  if (!cards.length) return

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    section.classList.add('site-principles--reduced')
    return
  }

  const transitions = Math.max(0, cards.length - 1)

  gsap.set(cards, { autoAlpha: 0 })
  gsap.set(cards[0], { autoAlpha: 1 })

  let refreshTimer = 0
  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer)
    refreshTimer = window.setTimeout(() => {
      ScrollTrigger.refresh()
    }, REFRESH_DEBOUNCE_MS)
  }

  const ro = new ResizeObserver(() => {
    scheduleRefresh()
  })
  ro.observe(track)

  const hold = PIN_SCROLL_HOLD_BEFORE_STEPS
  const move = 1 - hold

  const pinScrollLength = () => {
    const vh = window.innerHeight
    const segments = Math.max(1, transitions || 1)
    return (vh * SCROLL_END_MULTIPLIER * segments) / move
  }

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: `top ${HEADER_STICKY_PX}px`,
      end: () => `+=${pinScrollLength()}`,
      scrub: SCRUB_SMOOTHING,
      pin: true,
      pinSpacing: true,
      anticipatePin: 0,
      invalidateOnRefresh: true,
      onToggle: (self) => {
        section.classList.toggle('site-principles--pinned', self.isActive)
      },
    },
  })

  tl.to(cards[0], { autoAlpha: 1, duration: hold, ease: 'none' }, 0)

  if (transitions < 1) return

  const stepDur = move / transitions
  for (let i = 0; i < transitions; i++) {
    const t = hold + i * stepDur
    const a = cards[i]
    const b = cards[i + 1]
    if (!(a instanceof HTMLElement) || !(b instanceof HTMLElement)) continue
    tl.to(a, { autoAlpha: 0, duration: stepDur, ease: 'none' }, t)
    tl.to(b, { autoAlpha: 1, duration: stepDur, ease: 'none' }, t)
  }
}
